import React, { useState, useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'

const CartItem = ({ item, handleRemove, handleFavorite, handleChange, handleCloseError, isHideErrors }) => {
    let isFavorite = false

    if (__HappyFavorites) {
        isFavorite = __HappyFavorites.indexOf(item.PRODUCT_ID) !== -1
    }

    const isGift = useCallback((item) => {
        return item?.DETAIL_PAGE_URL?.split('/').includes('podarki');
    })

    return <>
        { (item.OLD_QUANTITY > item.AMOUNT && !isHideErrors) ? <div className={ `happy-cart__item-error-amount` }>
            <div className="happy-cart__item-error-amount-title">
                Количество товара в корзине превышает наличие на складе. В корзине был произведен автоматический перерасчёт!
            </div>
            <div className="happy-cart__item-error-amount-text">
                Пожалуйста перепроверьте свой заказ.
            </div>

            <span className="happy-cart__item-error-amount-close" onClick={ handleCloseError }></span>
        </div> : null }
        <div className={ `happy-cart__item happy-cart_grid` + ((item.OLD_QUANTITY > item.AMOUNT && !isHideErrors) ? ' happy-cart__item_error' : '') + (isGift(item) ? ' happy-cart__item-gift' : '') } data-id={ item.ID } data-product-id={ item.PRODUCT_ID }>
            <div className="happy-cart__item-td happy-cart__item-td_name">
                <div className="happy-cart__item-td-image">
                    { isGift(item) ? 
                        <span className="happy-cart__item-td-image-link" style={{ backgroundImage : `url( ${ item.PREVIEW_PICTURE } )` }}></span>
                    : 
                        <a href={ item.DETAIL_PAGE_URL } className="happy-cart__item-td-image-link" style={{ backgroundImage : `url( ${ item.PREVIEW_PICTURE } )` }}></a>
                    }
                </div>
                <div className="happy-cart__item-td-content">
                    <div className="happy-cart__item-td-title">
                        { isGift(item) ? item.NAME : <a href={ item.DETAIL_PAGE_URL } className="happy-cart__item-td-title-link">{ item.NAME }</a> }
                    </div>
                    <div className="happy-cart__item-td-amount">
                        { item.AMOUNT > 0 ? <span className="mark mark_instock">В наличии</span> : <span className="mark mark_not-available">Нет в наличии</span> }
                    </div>
                </div>
            </div>
            
            <div className="happy-cart__item-td happy-cart__item-td_price">
                { !isGift(item) && item.PRICE_FORMAT }
            </div>

            <div className="happy-cart__item-td happy-cart__item-td_quantity">
                { !isGift(item) && <div className="input-number">
                        <span className="input-number__increment input-number__increment_minus" onClick={ handleChange.bind(this, item, false) }>-</span>
                        <input
                            type="text"
                            defaultValue={ (item.OLD_QUANTITY > item.AMOUNT) ? item.AMOUNT : item.QUANTITY }
                            className="input-number__count"
                            onBlur={ handleChange.bind(this, item, 'blur') }
                            data-id={ item.ID }
                        />
                        <span className="input-number__increment input-number__increment_plus" onClick={ handleChange.bind(this, item, true) }>+</span>
                    </div>
                }
            </div>

            <div className="happy-cart__item-td happy-cart__item-td_summary">
                { !isGift(item) ? item.SUMMARY_FORMAT : '1 ₽' }

                { item.DISCOUNT_PRICE > 0 ? <>
                    <div className="happy-cart__item-td-discount">
                        { item.BASE_PRICE_SUMMARY_FORMAT }
                    </div>
                    <div className="happy-cart__item-td-discount-percent">
                        <span>Скидка -{ parseInt(Math.round(item.DISCOUNT_PERCENT)) } %</span>
                    </div>
                </> : null}
            </div>

            <div className="happy-cart__item-td happy-cart__item-td_actions">
                <button className={ `happy-cart__action happy-cart__action_favorite ${ isFavorite ? 'happy-cart__action_favorite_active' : '' }` } title="Добавить в избранное" onClick={ handleFavorite.bind(this, item) }></button>
                <button className="happy-cart__action happy-cart__action_remove" title="Удалить из корзины" onClick={ handleRemove.bind(this, item) }></button>
            </div>
        </div>
    </>
}

export default CartItem